import { FormControl, InputLabel, InputLabelProps, Select, SelectProps } from '@mui/material';
import React, { ReactElement } from 'react';
import { MoFieldErrorText } from '../MoFieldErrorText';

export interface MoSelectProps extends SelectProps {
  name: string;
  label: string;
  helperText?: string | ReactElement;
  InputLabelProps?: Partial<InputLabelProps>;
}

export function MoSelect({
  name,
  label,
  fullWidth = true,
  error,
  helperText,
  InputLabelProps: inputLabelProps,
  ...props
}: MoSelectProps): ReactElement {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id={`${name}-label`} error={error} {...inputLabelProps}>
        {label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        label={label}
        fullWidth={fullWidth}
        error={error}
        notched={inputLabelProps?.shrink || undefined}
        {...props}
      />
      {error && helperText && <MoFieldErrorText>{helperText}</MoFieldErrorText>}
    </FormControl>
  );
}
